import type { AnyAction } from 'redux';

import {
  FETCH_COLLECTION,
  FETCH_OLDEST_LINK,
  UPDATE_COLLECTION_LINKS_ACTIVE_COLUMNS_KEYS,
  UPDATE_SELECTED_COLLECTION_LINK_IDS,
} from '../../actions/Collection/CollectionActions';
import { reducerWrapper } from '../../support/utils';
import type { CollectionReducerType } from './types/CollectionReducerType';

export const INIT_STATE: CollectionReducerType = {
  loading: true,
  collection: undefined,
  oldestLink: undefined,
  selectedCollectionLinkIds: [],
  activeColumnKeys: [],
};

const Handler = (state: CollectionReducerType, action: AnyAction): CollectionReducerType => {
  switch (action.type) {
    case FETCH_COLLECTION.request:
      return {
        ...state,
        loading: true,
      };
    case FETCH_COLLECTION.response:
      return {
        ...state,
        loading: false,
        collection: action.data?.collection,
      };

    case FETCH_COLLECTION.error:
      return {
        ...state,
        loading: false,
      };

    case FETCH_OLDEST_LINK.response:
      return {
        ...state,
        oldestLink: action.data?.oldestLink,
      };
    case UPDATE_SELECTED_COLLECTION_LINK_IDS.response:
      return {
        ...state,
        selectedCollectionLinkIds: action.data?.selectedCollectionLinkIds,
      };
    case UPDATE_COLLECTION_LINKS_ACTIVE_COLUMNS_KEYS.response:
      return {
        ...state,
        activeColumnKeys: action.data?.activeColumnKeys,
      };
    default:
      return state;
  }
};

const TypelessHandler = (state: any, action: any) => {
  return Handler(state, action);
};

const CollectionReducer = reducerWrapper(INIT_STATE, TypelessHandler, {
  request: [FETCH_COLLECTION, FETCH_OLDEST_LINK],
  error: [FETCH_COLLECTION, FETCH_OLDEST_LINK],
});

export default CollectionReducer;
